// common
var MAX_LENGTH_PRICE = 8;
var MAX_LENGTH_OFFRATIO = 2;
var MAX_LENGTH_HEIGHT = 3;
var setTimeOut = ''; 
var SCROLL_Y = 0;

var pagenation = require('./components/pagenation.js');
var effect = require('./effect.js');

function isSafari() {
    return /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
}

function setCookie(cname, cvalue) {
    const d = new Date();
    d.setTime(d.getTime() + (30*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cookieName) {
    var name = cookieName + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === ' ') {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return '';
}

function cleanSS(obj) {
    for (var propName in obj) {
        if (!propName || obj[propName] === null || obj[propName] === undefined || obj[propName] === "" || propName === "") {
            delete obj[propName];
        }
    }

    decodeSpecialCharacter(obj);
    return obj
}

function setQueryStringSS(key) {
    var data = $('.js-ss-data-controller[data-key="' + key + '"]').data('query');
    var keyParam = key;
    if (key == 'storeType') {
        keyParam = data.hasOwnProperty('coordinate_label_id') ? 'coordinate_label_id' : 'shop_code';
    }
    if (key == 'storeTypeStaff') {
        keyParam = data.hasOwnProperty('label_code') ? 'label_code' : 'shop_code';
    }
    data[keyParam] = $('.js-ss-data-controller[data-key="' + key + '"]').data('value');
    data[keyParam] = data[keyParam].toString();
    $('.js-ss-data-controller').data('query', data);
}

function setQueryStringDataSS(key, aliasKey, aliasValue) {
    var data = $('.js-ss-data-controller[data-key="' + key + '"]').data('query');
    data[aliasKey] = aliasValue;
    $('.js-ss-data-controller').data('query', data);
}

function setQueryStringDataSelectFilterSS(_this, aliasKey, aliasValue) {
    var data = $(_this).data('query');
    data[aliasKey] = aliasValue;
    $(_this).data('query', data);
}

function clearFormatNumberSS(value) {
    var temp = value.toString().trim();
    temp = temp.replace(/[！-～]/g, halfwidthChar => String.fromCharCode(halfwidthChar.charCodeAt(0) - 0xfee0)); // convert fullwidth to halfwidth
    temp = temp.replaceAll("[^0-9.]", "");
    temp = parseInt(temp); // parse number
    return temp;
}

function setModalChooseSS(key, _this, isToggle, isMultiple) {
    if (isToggle) {
        // multiple choose and can toggle
        if (isMultiple) {
            var isHasClassActive = $(_this).hasClass('modal-choose--active-2');
            var value = $('.js-ss-data-controller[data-key="' + key + '"]').data('value').toString() || '';
            if (!isHasClassActive) { // add
                $(_this).addClass('modal-choose--active-2');
                value = value ? value.split(',') : [];
                value.push($(_this).data('value'));
            } else { // remove
                $(_this).removeClass('modal-choose--active-2');
                value = value ? value.split(',').map(v => v.trim()).filter(e => e != $(_this).data('value')) : [];
            }
            $('.js-ss-data-controller[data-key="' + key + '"]').data('value', value.join(','));
            setQueryStringSS(key);
            return;
        }
        // only one choose and can toggle
        if ($(_this).hasClass('modal-choose--active')) {
            $(_this).removeClass('modal-choose--active');
            $('.js-ss-data-controller[data-key="' + key + '"]').data('value', '');
            setQueryStringSS(key);
            return;
        }
    }
    // only one choose and must active
    $('.js-ss-data-controller[data-key="' + key + '"] .modal-choose').removeClass('modal-choose--active');
    $(_this).addClass('modal-choose--active');
    $('.js-ss-data-controller[data-key="' + key + '"]').data('value', $(_this).data('value'));
    setQueryStringSS(key);
}

function removeBadgeRow(badgeOption) {
    // setimeout run after function removeTagSelectedSS
    setTimeout(() => {
        var listBadge = $(badgeOption).find('.modal-tag');
        if (listBadge.length == 0) {
            $(badgeOption).remove();
        }
    }, 250);
}

function dfCheckDistance() {  
    var badgeLs = $('.badges-option');
    if(badgeLs.length > 0) {
        $(badgeLs).each((idx, elm) => {
            var tagsItem = $(elm).find('.modal-tag');
            if(tagsItem.length == 0) {
                $(elm).closest('.container').remove();
            }
        });
    }
}

// Remove Tag Selected
function removeTagSelectedSS(key, _this) {
    var cateId = $(_this).data('value');
    setTimeout(() => {
        $(_this).parent().remove();
    }, 200);
    var values = $('.js-ss-data-controller[data-key="' + key + '"]').data('value');
    if (typeof values == 'string' || typeof values == 'number') {
        values = values.toString().split(',').map(v => v.trim());
    }
    $('.js-ss-data-controller[data-key="' + key + '"]').data('value', values.filter(function (item) {
        return item != cateId;
    }));
    setQueryStringSS(key);
}

/**
 * Open modal if has data active
 */
function openModalChooseSS(key, className) {
    switch (key) {
        case "storeType":
        case "storeTypeStaff":
                if ($(`${className}`).find("input:checked").length > 0) {
                    $(`${className}`).prev('.staff-styling__plus').trigger('click');
                }            
            break;
        case "category":
            $('.checkbox-item').each(function () {
                var dataParent = $(this).data('parent');
                var elmParent = $(`#${dataParent}`);
                var isHasChecked = elmParent.find("input:checked").length;
                if (isHasChecked > 0) {
                    $(this).removeClass('collapsed');
                    elmParent.show();
                }
            });
        break;
        default:
            break;
    }

}

function openModalChildSS(key, _this) {
    var ww = $(window).width();
    var url = $(_this).data('url');
    var payload = $(_this).data('query');

    if (!payload) {
        payload = $('.js-ss-data-controller[data-key="' + key + '"]').data('query');
    }
    url += '?key=' + key + '&' + $.param(payload);
    url = url.replace(/&$/, '');
    console.log("== payload ==");
    console.log(payload);
    $.ajax({
        url: url,
        type: 'GET',
        success: function (response) {
            if(ww < 768){
                $('#zigzag-worldshopping-checkout').addClass('none-worldshopping');
                $('#zigzag-worldshopping-checkout').removeAttr('style');
            }
            if (!response.error) {
                $('.js-ss-content-modal').html(response.html);
                attachScrollEventToModal();

                $('#modal-filter').modal('show');
                calcDisplayBtnBrand();
            }
            openModalChooseSS(key, '#storeGroup-collapsed');
            openModalChooseSS(key, '#store-collapsed');
            dfCheckDistance();

            // remove border bottom
            var endItem = $(".end_item");
            if (endItem.length > 0) {
                $(endItem[endItem.length - 1]).removeClass('end_item');
            }
        },
        error: function (error) {
            console.log(error);
        }
    });
}

function validateAndLoadDataInputSS(_this, input, maxLength) {
    var aliasKey = $(_this).data('injectkey');
    var aliasValue = $(_this).data('injectvalue');
    var value = $(_this).val().toString().trim().slice(0, maxLength);
    var number = clearFormatNumberSS(value);
    var numberTXT = number.toString();
    if (isNaN(numberTXT)) {
        numberTXT = '';
    }
    $(_this).val(numberTXT);
    $('.js-ss-data-controller[data-key="' + input + '"]').data(aliasValue, numberTXT);
    setQueryStringDataSS(input, $('.js-ss-data-controller[data-key="' + input + '"]').data(aliasKey), numberTXT);
}

function handleCategorySS(_this, key) {
    var arrElement = $('.js-ss-content-modal :checkbox:checked');
    var txt = [];
    arrElement.each((index, element) => {
        if (!!$(element).data('value2')) {
            var arrIDs = $(element).data('value2');
            if (arrIDs) {
                arrIDs = arrIDs.toString().split(',');
                for (let i = 0; i < arrIDs.length; i++) {
                    var id = arrIDs[i];
                    var ids = $('.js-ss-content-modal :checkbox[data-parent=' + id + ']').map(function () {
                        return $(this).val();
                    }).get().join(',');
                    txt.push(ids);
                }
            }
        }
        else if (!!$(element).data('value3')) {
            txt.push($(element).data('value3'));
        }
        else {
            txt.push($(element).val());
        }
    });
    txt = txt.join(',');
    handleParentIds(txt); // set cookie for detect choice parent category or child category
    setQueryStringDataSelectFilterSS($('.js-ss-select-filter'), 'category_prefix_final', txt);
    openModalChildSS(key, _this);
}

function handleParentIds(categoryPrefixFinal) {
    setCookie('parentIds', '');
    var arrIDs = [];
    var checkedData = $('.parents_category:checked');
    if (checkedData.length > 0) {
        checkedData.each((index, element) => {
            var val2 = $(element).val();
            if (val2) {
                arrIDs.push(val2);
            }
        });
        arrIDs = arrIDs.join('|');
        setCookie('parentIds', arrIDs);
    }

    // set real data url
    setCookie('category_prefix_final', categoryPrefixFinal.replace(/,/g, "|"));
}

function handleBrandSS(_this, key, payload) {
    var buyingKey = 'buying';
    var labelKey = 'label';
    var onlyOneItem;
    var tempObj = {};
    var checkedItem = $('.js-ss-content-modal :checkbox:checked');

    if (checkedItem.length > 0) {
        $('.js-ss-content-modal :checkbox:checked').each(function () {
            var datakey = $(this).data('key');
            onlyOneItem = datakey;
            if (!tempObj[datakey]) {
                tempObj[datakey] = [];
            }

            if (tempObj[datakey]) {
                tempObj[datakey].push($(this).val());
            }
        });
    } else {
        delete payload[labelKey];
        delete payload[buyingKey];
    }

    // just select 1 in 2
    if (onlyOneItem == buyingKey) {
        delete payload[labelKey];
    } else {
        delete payload[buyingKey];
    }

    if (tempObj[onlyOneItem]) {
        payload[onlyOneItem] = tempObj[onlyOneItem].join(',');
    }

    delete payload['brand_ss'];

    $(_this).data('query', payload);
    openModalChildSS(key, _this);
}

function handleStoreTypeSS(_this, key, payload) {
    delete payload.coordinate_label_id;
    delete payload.shop_code;
    var parameter = $('#storeGroup-collapsed').find("input:checked").length > 0 ? 'coordinate_label_id' : 'shop_code';
    payload[parameter] = payload.storeType;
    delete payload.storeType;
    $(_this).data('query', payload);
    openModalChildSS(key, _this);
}

function handleStoreTypeStaff(_this, key, payload) {
    delete payload.label_code;
    delete payload.shop_code;
    var parameter = $('#storeGroup-collapsed').find("input:checked").length > 0 ? 'label_code' : 'shop_code';
    payload[parameter] = payload.storeTypeStaff;
    delete payload.storeTypeStaff;
    $(_this).data('query', payload);
    openModalChildSS(key, _this);
}

function filterCategory(data) {
    const { category_prefix_final, category } = data;

    const prefixFinals = category_prefix_final.split(',').map(item => item.trim());

    const categories = category.split(',').map(item => item.trim());

    return prefixFinals.filter(prefix => {
        return categories.some(cat => {
            return prefix.startsWith(cat) || prefix === cat;
        });
    });
}

// 2024/09/20 delete function
// tag effect only mobile
// function tagEffect(element, color = '#eaeaea') {
//     if ( $(window).width() <= 768) {
//         $(element).css('background-color', color);
//         setTimeout(() => {
//             $(element).css('background-color', '#fff');
//         }, 100);
//     }
// }

// Event
// Staff start store rule: only choice 1 in 2
$('body').on('change', '.js_staffstart_store', function () {
    if ($(this).is(':checked')) {
        var currentDataKey = $(this).data('key');

        var targetDataKey = currentDataKey == 'coordinate_label_id' ? 'shop_code' : 'coordinate_label_id';

        $('.js_staffstart_store[data-key="' + targetDataKey + '"]').each(function () {
            $(this).prop('checked', false);
        });
    }
});

// active button
$('body').on('click', '.js-ss-data-controller .modal-choose', function (e) {
    var dataKey = $(this).closest('.js-ss-data-controller').attr('data-key');
    switch (dataKey) {
        case 'gender':
            setModalChooseSS('gender', this);
            break;
        case 'display_mode':
            setModalChooseSS('display_mode', this);
            break;
        case 'quantityItem':
            setModalChooseSS('quantityItem', this);
            break;
        case 'price_type':
            setModalChooseSS('price_type', this, true, true);
            break;
        case 'selling_type':
            setModalChooseSS('selling_type', this, true, true);
            break;
        case 'exclusive':
            setModalChooseSS('exclusive', this, true, true);
            break;
        case 'in_stock':
            setModalChooseSS('in_stock', this, true, true);
            break;
        default:
            break;
    }
    e.stopPropagation();
});

// Input Filter in Modal - Level 1
$('body').on('input', '.js-ss-data-controller[data-key="offRatio"] .js-ss-input-change', function (e) {
    e.stopPropagation();
    txtFullWidthCheck(this, 'offRatio', MAX_LENGTH_OFFRATIO);
})

$('body').on('input', '.js-ss-data-controller[data-key="price"] .js-ss-input-change', function (e) {
    e.stopPropagation();
    txtFullWidthCheck(this, 'price', MAX_LENGTH_PRICE);
})

$('body').on('input', '.js-ss-data-controller[data-key="height"] .js-ss-input-change', function (e) {
    e.stopPropagation();
    txtFullWidthCheck(this, 'height', MAX_LENGTH_HEIGHT);
});

// Remove Tag Selected
$('body').on('click', '.js-ss-brand .js-ss-modal-tag__close', function (e) {
    //effect.effectChangeOpacity(this, null, effect.BEFORE_OPACITY, effect.AFTER_OPACITY);
    var badgeOption = $(this).closest('.badges-option');
    var _this = $(this).find('.modal-tag__close');
    var dataKey = $(this).data('key');
    var parentElm = $(this).closest('.js-ss-brand');
    parentElm.attr('data-key', dataKey);
    parentElm.find('.js-ss-open-modal-lv2').attr('data-key', dataKey);
    e.stopPropagation();
    removeTagSelectedSS(dataKey, _this);
    removeBadgeRow(badgeOption);
});

$('body').on('click', '.js-ss-data-controller:not(.js-ss-brand) .js-ss-modal-tag__close', function (e) {
    //effect.effectChangeOpacity(this, null, effect.BEFORE_OPACITY, effect.AFTER_OPACITY);
    var badgeOption = $(this).closest('.badges-option');
    var dataKey = $(this).closest('.js-ss-data-controller').attr('data-key');
    var _this = $(this).find('.modal-tag__close');
    removeTagSelectedSS(dataKey, _this);
    removeBadgeRow(badgeOption);
    e.stopPropagation();
});


$('body').on('click', '.js-ss-data-controller[data-key="storeType"] .js-ss-modal-tag__close', function (e) {
    e.stopPropagation();
    //effect.effectChangeOpacity(this, null, effect.BEFORE_OPACITY, effect.AFTER_OPACITY);
    var badgeOption = $(this).closest('.badges-option');
    var _this = $(this).find('.modal-tag__close');
    removeTagSelectedSS('storeType', _this);
    removeBadgeRow(badgeOption);
});

$('body').on('click', '.js-ss-data-controller[data-key="storeTypeStaff"] .js-ss-modal-tag__close', function (e) {
    e.stopPropagation();
    //effect.effectChangeOpacity(this, null, effect.BEFORE_OPACITY, effect.AFTER_OPACITY);
    var badgeOption = $(this).closest('.badges-option');
    var _this = $(this).find('.modal-tag__close');
    removeTagSelectedSS('storeTypeStaff', _this);
    removeBadgeRow(badgeOption);
});

$('body').on('click', '.js-ss-data-controller[data-key="base_product_code"] .js-ss-modal-tag__close', function (e) {
    e.stopPropagation();
    //effect.effectChangeOpacity(this, null, effect.BEFORE_OPACITY, effect.AFTER_OPACITY);
    var badgeOption = $(this).closest('.badges-option');
    var _this = $(this).find('.modal-tag__close');

    setTimeout(() => {
        $(_this).parent().remove();
    }, 200);

    var queryData = $('.js-ss-data-controller').data('query');
    delete queryData.base_product_code;
    delete queryData.base_product_name;
   
    $('.js-ss-data-controller').data('query', queryData);
    removeBadgeRow(badgeOption);
});

// Submit Filter
$('body').on('click', '.js-ss-submit-filter', function (e) {
    e.stopPropagation();
    effect.effectChangeOpacity(this, null, effect.BEFORE_OPACITY, effect.AFTER_OPACITY);
    var payload = $('.js-ss-data-controller').data('query');
    if (payload.category_prefix_final) {
        if (payload.category) {
            var resultFilter = filterCategory(payload);
            if (resultFilter.length > 0) {
                payload.category = resultFilter.join(',');
            } else {
                payload.category = payload.category;
            }
            
        }
        delete payload.category_prefix_final;
    }

    delete payload.page;
    delete payload.start;

    payload = cleanSS(payload);
    console.log("payload", payload);
    var path = window.location.href.split('?')[0];
    path += $.param(payload) ? '?' + $.param(payload) : '';
    window.location.href = path;
});

// Submit Select Filter
$('body').on('click', '.js-ss-select-filter', function (e) {
    e.stopPropagation();
    var payload = $(this).data('query');
    var key = $(this).data('key');
    var keyreplace = $(this).data('keyreplace');
    var value = $('.js-ss-content-modal :checkbox:checked').map(function () {
        return $(this).val();
    }).get();

    payload[keyreplace] = value.join(',');
    effect.effectChangeOpacity(this, null, effect.BEFORE_OPACITY, effect.AFTER_OPACITY);
    switch (keyreplace) {
        case 'category':
            handleCategorySS(this, key);
            break;
        case 'brand_ss':
        case 'buying':
        case 'label':
            handleBrandSS(this, key, payload);
            break;
        case 'storeType':
            handleStoreTypeSS(this, key, payload);
            break;
        case 'storeTypeStaff':
            handleStoreTypeStaff(this, key, payload);
            break;
        default:
            $(this).data('query', payload);
            openModalChildSS(key, this);
            break;
    }
});

// Clear selected filter
$('body').on('click', '.js-ss-clear-filter', function (e) {
    e.stopPropagation();
    effect.effectChangeBackgroundColor(this, null, effect.BEFORE_COLOR, effect.AFTER_COLOR);
    $('.js-ss-content-modal :checkbox:checked').prop('checked', false);
});

// Modal lv 1 -> Open to lv 2
$('body').on('click', '.js-ss-data-controller', function (e) {
    e.stopPropagation();
    var _this = $(this).find('.js-ss-open-modal-lv2');
    if (_this.length == 0 || !_this.data('key')) {
        return;
    }
    effect.effectChangeBackgroundColor(this, null, effect.BEFORE_COLOR, effect.AFTER_COLOR);
    openModalChildSS($(_this).data('key'), _this)
})

// Modal lv 2 -> back to lv 1
$('body').on('click', '.js-ss-back-modal-lv1', function (e) {
    e.stopPropagation();
    effect.effectChangeOpacity(this, null, effect.BEFORE_OPACITY, effect.AFTER_COLOR);
    $('.subtitle--left:before').css('opacity', 0.4)
    openModalChildSS($(this).data('key'), this)

})

// Modal lv 2 -> back to lv 1
$('body').on('click', '.button_filter', function () {
    var tmpPayload = $('.js-ss-data-query').data('query');
    var dataKey = $(this).data('key');
    $(this).data('query', tmpPayload);
    openModalChildSS(dataKey, this)
});

// handle button to top
var buttonToTop = $('.button_to_top');
$(window).on("scroll", function () {
    if ($(this).scrollTop()) {
        buttonToTop.addClass('show');
    } else {
        buttonToTop.removeClass('show');
    }
});

buttonToTop.on('click', function (e) {
    e.preventDefault();
    window.scrollTo(0,0);
});

// handle event radio grouping change
$('.js-ss-grouping-radio-change, .js-ss-sort-plp').on('change', function (e) {
    e.stopPropagation();

    var payload = $(this).data('query');
    var key = $(this).data('key');
    var valueDefault = $(this).data('valuedefault');
    payload = cleanSS(payload);
    payload[key] = $(this).val() ? $(this).val() : valueDefault;
    var path = window.location.href.split('?')[0];
    payload = cleanSS(payload);
    path += $.param(payload) ? '?' + $.param(payload) : '';
    window.location.replace(path);
})
// handle button to top in modal
function attachScrollEventToModal() {
    $('.modal-body').on('scroll', function () {
        if ($(this).scrollTop()) {
            $('.btn-scrolltop').fadeIn();
        } else {
            $('.btn-scrolltop').fadeOut();
        }
    });
}

$(document).on('click', '.btn-scrolltop', function (e) {
    $('.modal-body').scrollTop(0);
    e.preventDefault();
});

// event viewmore handle
$(document).ready(function () {
    var initViewmore = function () {
        if ($('.tag__wrap').height() > 200 && $(window).width() <= 768) {
            $('.tag__viewmore').show();
            $('.tag__wrap').removeClass('active');
        } else {
            $('.tag__viewmore').hide();
            $('.tag__wrap').addClass('active');
        }
    }
    $(window).on('resize', function () {
        pagenation.adjustMargins('.pc-display');
        pagenation.adjustMargins('.sp-display');
        initViewmore();
        $('.tag__viewmore').removeClass('active');
        $('.tag__viewmore').text($('.tag__viewmore').data('txt'))
    });
    initViewmore();
})

$('.js-ss-open-modal-filter').on('click', function (e) {
    if ($(window).width() <= 768) {
        SCROLL_Y = window.scrollY;
        $('#modal-filter').css('background-color', '#fff');
    }
    var idModal = $(this).data('modal');
    openModalChildSS('main', this);
    $(idModal).modal('show');
    $('body').find('.js-ss-data-controller[data-key="keywords"] .js-ss-input-change').trigger('input');
    setTimeout(() => {
        $('body').find('.js-ss-data-controller[data-key="keywords"] .js-ss-input-change').trigger('focus');
    }, 500);
})

$('.tag__viewmore').on('click', function (e) {
    $('.tag__wrap').toggleClass('active');
    $(this).toggleClass('active');
    $(this).text().trim() === $(this).data('txt') ? $(this).text($(this).data('txtclose')) : $(this).text($(this).data('txt'))
})

$('body').on('click', '.js-ss-data-controller[data-key="keywords"] .icon-search', function (e) {
    $('body').find('.js-ss-data-controller[data-key="keywords"] .js-ss-input-change').val('').trigger('input');
})

//staff sorting
var getCurrentParamsUrl = (url) => {
    return Object.entries(Object.fromEntries(new URLSearchParams(new URL(url).search))).reduce((a, [k, v]) => (v == '' && v ? a : (a[k] = v, a)), {});
};

$(function () {
    $('#sortFilterStaff').on('change', function (e) {
        e.preventDefault();
        var currentParams = new URLSearchParams(window.location.search);
        currentParams.set('sort', $(this).val());
        var newURL = window.location.pathname + '?' + currentParams.toString();
        // Update the URL  reloading the page
        window.location.href = newURL;
    });
});

//handle plus
$('body').on('click', '.staff-styling__plus', function () {
    effect.effectChangeBackgroundColor(this, null, effect.BEFORE_COLOR, effect.AFTER_COLOR);
    $(this).toggleClass('active');
    $(this).next().find('.accordion-collapse').toggleClass('show');
})


$('.product-list__column01').on('click', function (e) {
    e.preventDefault();
    $('.items-select-option').removeClass('d-block');
    $('.staff-list__item').addClass('is-active');
    $('.styling_items').addClass('is-active');
    $('.styling_items').find('.styling_item').addClass('is-active');
    $('.product-list__column01').removeClass('is-active');
    $('.product-list__column02').addClass('is-active');
    setCookie('numberColumn', 3);
    detectWidthTextBox();
    return false;
})

$('.product-list__column02').on('click', function (e) {
    e.preventDefault();
    $('.items-select-option').removeClass('d-block');
    $('.staff-list__item').removeClass('is-active');
    $('.styling_items').removeClass('is-active');
    $('.product-list__column01').addClass('is-active');
    $('.styling_items').find('.styling_item').removeClass('is-active');
    $('.product-list__column02').removeClass('is-active');
    setCookie('numberColumn', 2);
    detectWidthTextBox();
    return false;
})

//handle wishlist
$('body').on('click', '.add-staff-styling-no-login img', function () {
    $('.staff-styling-add-wishlist').not($(this).closest('.add-staff-styling-no-login').find('.staff-styling-add-wishlist')).addClass('d-none');
    var redirect = window.location.href;
    var url = $('.staff-styling-url-redirect').attr('href');
    $('.staff-styling-url-redirect').attr('href', url + '?redirect=' + redirect);
    $(this).closest('.add-staff-styling-no-login').find('.staff-styling-add-wishlist').toggleClass('d-none');

    var currentItem = $(this).closest('.js_item');
    if (currentItem.length > 0) {
        var itemRight = currentItem.offset().left + currentItem.outerWidth();
        var windowWidth = $(window).width();
        var distanceToRight = windowWidth - itemRight;
        var currentWithLoginBox = 313;
        // check last item in current row 
        if (windowWidth > 769 && distanceToRight < (currentWithLoginBox / 2)) {
            $(currentItem).find('.staff-styling-add-wishlist').css('transform', `translateX(calc(-50% - ${distanceToRight + 30}px))`);
        }
    }
});

$('body').on('click', '.wishlist-staff-styling-isLogged img', function () {
    var action = $(this).data('action');
    var pid = $(this).data('pid');
    var form = {
        pid: pid,
        sid: $(this).data('sid'),
        name: $(this).data('name'),
        action: action
    }
    var dataLayerStaffStyling = $('input[name="dataLayer"]').val() ? JSON.parse($('input[name="dataLayer"]').val()) : {};
    var popup = $(this).siblings('.popup-notify');
    $.ajax({
        url: $(this).data('url'),
        method: 'POST',
        data: form,
        success: function (response) {
            if (!response.error) {
                var text = '';
                switch (action) {
                    case 'add':
                        $('.img-' + pid + '-remove-wishlist').removeClass('d-none');
                        $('.img-' + pid + '-add-wishlist').addClass('d-none');
                        $('.img-' + pid + '-remove-wishlist').attr("data-sid", response.data[0]._id);
                        $('.img-' + pid + '-add-wishlist').attr("data-sid", response.data[0]._id);
                        text = Resources.WISHLIST_STAFF_NOTIFY_ADD_ITEM;
                        if (response.queryString == 'type=styling') text = Resources.WISHLIST_STYLING_NOTIFY_ADD_ITEM;
                        //dataLayer
                        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                        dataLayer.push({
                            user_id: dataLayerStaffStyling && dataLayerStaffStyling.user_properties ? dataLayerStaffStyling.user_properties.customer_id : '',
                            event: response.queryString === 'type=styling' ? "add_to_wishlist_styling" : "add_to_wishlist_staff",
                            ecommerce: {
                                currency: 'JPY',
                                items: response.items
                            }
                        });
                        break;
                    case 'remove':
                        $('.img-' + pid + '-remove-wishlist').addClass('d-none');
                        $('.img-' + pid + '-add-wishlist').removeClass('d-none');
                        text = Resources.WISHLIST_STAFF_NOTIFY_REMOVE_ITEM;
                        if (response.queryString == 'type=styling') text = Resources.WISHLIST_STYLING_NOTIFY_REMOVE_ITEM;
                        break;
                    default:
                        break;
                }
                // add notify
                popup.find('.content-popup-notify').html(text);
                popup.toggleClass('show');
                setTimeout(function () {
                    popup.removeClass('show');
                }, 1000);
            } else {
                $('.text_wishlist_error').html(response.msg);
                $('.popup-wishlist-error').trigger('click');
            }
        },
    });

});

$(document).on('click', function(e){
    if ($(e.target).closest('.wishlist').length === 0) {
        $('.staff-styling-add-wishlist').addClass('d-none');
    }
});

//submit clear choose level1
$('body').on('click', '.js-ss-clear-choose-level1', function() {
    effect.effectChangeBackgroundColor(this, null, effect.BEFORE_COLOR, effect.AFTER_COLOR);
    var orgQuery = $('.js-ss-data-query').data('query');
    var tempQuery = {};
    if (orgQuery.sort) {
        tempQuery.sort = orgQuery.sort;
    }
    tempQuery.gender = 30;
    $(".js-ss-data-controller").each(function() {
        $('.tmpQueryString').val(tempQuery);
        $(this).data('query', tempQuery);
        $('.js-ss-modal-tag__close').remove();
        $('.js-ss-input-change').val('');
        $('.modal-choose').removeClass('modal-choose--active');
        $('.modal-choose[data-value="30"]').addClass('modal-choose--active');
    });
});

$('body').on('input', '.js-ss-input-same-type', function (e) {
    e.stopPropagation();
    if ($(this).is(':checked')) {
        var type = $(this).data('type');
        $('.js-ss-input-same-type:not([data-type="' + type + '"])').prop('checked', false);
    }
});

$('body').on('input', '.js-ss-input-same-type-category', function (e) {
    e.stopPropagation();
    var id = null;
    var parent = null;
    if ($(this).is(':checked')) {
        id = $(this).data('id');
        parent = $(this).data('parent');
        if (!!id && !!parent) { // Check LV 3
            $('.js-ss-input-same-type-category[data-id="' + parent + '"]').prop('checked', false);
            $('.js-ss-input-same-type-category[data-parent="' + id + '"]').prop('checked', false);
        }
        else if (!!id) { // Check LV 2
            $('.js-ss-input-same-type-category[data-parent="' + id + '"]').prop('checked', false);
            var arrElement = $('.js-ss-input-same-type-category[data-parent="' + id + '"]');
            if (arrElement.length) {
                arrElement.each((index, element) => {
                    var eID = $(element).data('id');
                    $('.js-ss-input-same-type-category[data-parent="' + eID + '"]').prop('checked', false);
                });
            }
        }
        else if (!!parent) { // Check LV 4
            $('.js-ss-input-same-type-category[data-id="' + parent + '"]').prop('checked', false);
            parent = $('.js-ss-input-same-type-category[data-id="' + parent + '"]').data('parent');
            if (!!parent) {
                $('.js-ss-input-same-type-category[data-id="' + parent + '"]').prop('checked', false);
            }
        }
    }
})

$('body').on('click', '.js_tag_remove', function (e) {
    effect.effectChangeOpacity(this, null, effect.BEFORE_OPACITY, effect.AFTER_OPACITY);
    setTimeout(() => {
        var dataKey = $(this).data('key');
        var dataQuery = $(this).closest('.tags_chose').data('query');

        switch (dataKey) {
            case 'user_id':
                delete dataQuery.user_name;
                break;
            case 'base_product_code':
                delete dataQuery.base_product_code;
                delete dataQuery.base_product_name;
                break;
            default:
                break;
        }

        $(this).remove();

        dataQuery[dataKey] = [];
        var tagList = $(`.js_tag_remove`);
        if (tagList.length > 0) {
            tagList.each(function () {
                var dataKeyItem = $(this).data('key');
                if (!dataQuery[dataKeyItem] || typeof dataQuery[dataKeyItem] === "string") {
                    dataQuery[dataKeyItem] = [];
                }
                dataQuery[dataKeyItem].push($(this).data('value'));
            });
        }

        // clean object before reload
        for (var key in dataQuery) {
            if (Array.isArray(dataQuery[key]) && dataQuery[key].length === 0) {
                delete dataQuery[key];
            }
        }

        delete dataQuery.category_prefix_final;
        delete dataQuery.start;
        delete dataQuery.page;

        decodeSpecialCharacter(dataQuery);

        if (dataQuery.gender === undefined || (dataQuery.gender && (dataQuery.gender.length === 0 || dataQuery.gender.length === 2))) {
            dataQuery.gender = 30;
        }
        
        var endUrl = new URL(window.location.href);
        endUrl.search = new URLSearchParams(dataQuery).toString();
        
        window.location.href = endUrl.href;
    }, 200);
});


$('body').on('click', '.accordinate_item', function (e) {
    var dataParent = $(this).data('parent');
    $(this).toggleClass('collapsed');

    if ($(this).hasClass('collapsed')) {
        $(`#${dataParent}`).hide();

        if ($(this).hasClass('end_item')) {
            $(this).removeClass('important-bd');
        }

    } else {
        $(`#${dataParent}`).show();

        if ($(this).hasClass('end_item')) {
            $(this).addClass('important-bd');
        }
    }
});

$(document).on('click', '.alphabet__item a', function (e) {
    effect.effectChangeBackgroundColor(this.closest('.alphabet__item'), null, effect.BEFORE_COLOR, effect.AFTER_COLOR);
    var letter = $(this).data('id');
    var elmScroll = $(`#${letter}`);
    setTimeout(() => {
        if (elmScroll) {
            elmScroll[0].scrollIntoView();
        }
    }, 200);
});

$('body').on('click', '.modal-filter-sys-ss .checkbox-item', function(event) {
    if ($(this).closest('.storeGroup-collapsed').length > 0) {
        $(".store-collapsed").find('input').prop('checked', false);
    } else {
        $(".storeGroup-collapsed").find('input').prop('checked', false);
    }
    effect.effectChangeBackgroundColor(this, null, effect.BEFORE_COLOR, effect.AFTER_COLOR);
    event.stopPropagation();
});

$(function() {
    var totalHeightTags = 0;
    $(".js_tag_remove").each(function() {
        if (totalHeightTags <= 162 || $(window).width() > 768) {
            $(this).removeClass('d-none');
        }
        totalHeightTags = $('.list_chose').height();
        if (totalHeightTags > 162 && $(window).width() <= 768) {
            $(this).addClass('d-none');
        }
        if ($(this).hasClass('d-none')) {
            $(this).addClass('is-closed');
        }
    })
    if ($('.list_chose').height() > 102) {
        $(".view_more").removeClass('d-none');
    }
    $('.view_more').on('click', function () {
        $(this).addClass('d-none');
        $(".js_tag_remove").removeClass('d-none');
        $(".closed").removeClass('d-none');
    });
    
    $('.closed').on('click', function () {
        $(this).addClass('d-none');
        $(".is-closed").addClass('d-none');
        $(".view_more").removeClass('d-none');
    });
});

// Open sorting rule sp
$('body').on('click', '.js-ss-sorting-rule-sp', function (e) {
    $('.items-select-option').toggleClass('d-block');
});

$('body').on('click', function (e) {
    if (e.target.closest('.js-ss-sorting-rule-sp') == null && e.target.closest('.items-select-option') == null ) {
        $('.items-select-option').removeClass('d-block');
    }
});

$(function () {
    $('.items-select-option .select-option').on('click', function (e) {
        e.preventDefault();
        $(this).addClass('sorting-rule-active');
        var currentParams = new URLSearchParams(window.location.search);
        currentParams.set('sort', $(this).data('value'));
        var newURL = window.location.pathname + '?' + currentParams.toString();
        // Update the URL  reloading the page
        setTimeout(() => {
            $(this).removeClass('sorting-rule-active');
            window.location.href = newURL;
        }, 100);
        
    });

    // replace parameter form url
    var searchParams = new URLSearchParams(window.location.search);
    var coordinate_genre = searchParams.get('coordinate_genre');
    var gender = searchParams.get('gender');
    var coordinate_label_id = searchParams.get('coordinate_label_id');
    var shop_code = searchParams.get('shop_code');
    var label_code = searchParams.get('label_code');

    if (coordinate_genre) {
        coordinate_genre = coordinate_genre == 1 ? 20 : 10;
        setCookie('cgid', coordinate_genre);
        searchParams.set('gender', coordinate_genre);
        searchParams.delete('coordinate_genre');
        history.pushState(null, null, "?"+searchParams.toString());
    }

    if (['1','2'].includes(gender)) {
        gender = gender == 1 ? 10 : 20;
        setCookie('cgid', gender);
        searchParams.set('gender', gender);
        history.pushState(null, null, "?"+searchParams.toString());
    }

    if (coordinate_label_id && shop_code) {
        searchParams.delete('coordinate_label_id');
        history.pushState(null, null, "?"+searchParams.toString());
    }

    if (label_code && shop_code) {
        searchParams.delete('label_code');
        history.pushState(null, null, "?"+searchParams.toString());
    }
    
    var valueCategory = $("input[name=js-ss-value-category]").val();
    var isRedirect = $("input[name=js-ss-value-isRedirect]").val();
    var valueCategoryPrefixFinal = $("input[name=js-ss-value-category_prefix_final]").val();
    var valueCategoryParentIds = $("input[name=js-ss-value-parentIds]").val();
    if (isRedirect == 'true' && valueCategory != valueCategoryPrefixFinal) {
        setCookie('category_prefix_final', valueCategoryPrefixFinal.replace(/,/g, "|"));
        setCookie('parentIds', valueCategoryParentIds);
        searchParams.set('category', valueCategoryPrefixFinal);
        var newURL = window.location.pathname + '?' + searchParams.toString();
        window.location.href = newURL;
    }

    // fit margin button pagination
    var ww = $(window).width();

    if (ww >= 992) {
        calcMgButton();
    }

    pagenation.adjustMargins('.pc-display');
    pagenation.adjustMargins('.sp-display');
});

$('body').on('click', '.close-modal, .modal-backdrop', function (e) {
    var ww = $(window).width();
    effect.effectChangeBackgroundColor(this, null, effect.BEFORE_COLOR, effect.AFTER_COLOR);
    if(ww < 768){
        $('#zigzag-worldshopping-checkout').remove('none-worldshopping');
        $('#zigzag-worldshopping-checkout').attr('style', 'all: initial !important;');
    }
});

function calcDisplayBtnBrand() {
    var modalBody = $(".modal-filter-sys-ss .modal-body");
    var heightMdHeader = $(".modal-filter-sys-ss .modal-header").outerHeight(true);
    var heightMdFooter = $(".modal-filter-sys-ss .modal-footer").outerHeight(true);
    var calcMdBody = heightMdFooter + heightMdHeader;
        $(modalBody).css('height', `calc(100vh - ${calcMdBody}px)`);
}

$('body').on('click', '.header__hamburger', function () {
    var getCookieCgid = getCookie('cgid');
    if (getCookieCgid) {
        $('.tab').find('li').removeClass('active');
        $('.block2_2').find('.area').removeClass('is-active');
        $('.tab').find(`.tabName__${getCookieCgid}`).addClass('active');
        $('.block2_2').find(`.tabContent__${getCookieCgid}`).addClass('is-active');
    }
})


$('body').on('click' ,'.ranking__btn a', function(e) {
    e.preventDefault();
    effect.effectChangeBackgroundColor(this, null, effect.BEFORE_COLOR, effect.AFTER_COLOR);
    setTimeout(() => {
        var href = $(this).attr('href')
        window.location = href;
    }, 200);
});

$('body').on('click', '.row_tag .effect_active_sp', function(e) {
    e.preventDefault();
    effect.effectChangeOpacity(this, null, effect.BEFORE_OPACITY, effect.AFTER_OPACITY);
    setTimeout(() => {
        var href = $(this).attr('href')
        window.location = href;
    }, 200);
});

function getDistanceToRightExcludingPadding(element) {
    var rect = element.getBoundingClientRect();
    var computedStyle = window.getComputedStyle(element);
    var paddingRight = parseFloat(computedStyle.paddingRight);
    var distanceToRight = window.innerWidth - rect.right + paddingRight;
    return distanceToRight;
}

function calcMgButton() {
    var btnWidth = $('.button_to_top_ss');
    var elmSS = document.querySelectorAll('.calcMg');
    var wBtn = btnWidth.outerWidth(true);
    elmSS.forEach(function(element) {
        var distance = getDistanceToRightExcludingPadding(element);
        if (distance > wBtn) {
            var calcMgBtn = distance - wBtn - 16;
            $(btnWidth).css('right', `${calcMgBtn}px`);
        }
    });
}

$('body').on('click', '.pagenation_effect', function (e) {
    e.preventDefault();
    effect.effectChangeOpacity(this, null, effect.BEFORE_OPACITY, effect.AFTER_OPACITY);
    const target = $(this).attr('href');
    window.location = target;
})

$('body').on('click', '.custom__flex_wrap a', function (e) {
    e.preventDefault();
    $(this).css('background-color', '#bebbbb');
    setTimeout(() => {
        $(this).css('background-color', '#fff');
    }, 100);
    setTimeout(() => {
        var href = $(this).attr('href')
        window.location = href;
    }, 200);
})

function decodeSpecialCharacter(dataQuery) {  
    if (dataQuery.base_product_name) {
        dataQuery.base_product_name = decodeURIComponent(dataQuery.base_product_name);
    }
}

/*
 * Post-processing after close
 */
$("#modal-filter").on("hide.bs.modal", function () {
    if ($(window).width() <= 768) {
        $("body").css("position", "static");
        window.scrollTo(0, SCROLL_Y);
    }
});
$("#modal-filter").on("hidden.bs.modal", function () {
    if ($(window).width() <= 768) {
        $(".modal-content").html("");
        window.scrollTo(0, SCROLL_Y);
    }
});

$("#modal-filter").on("shown.bs.modal", function () {
    if ($(window).width() <= 768) {
        $(".modal-open").css("position", "fixed");
    }
});
function txtFullWidthCheck(_this, key, maxlength) {  
    if (isSafari()) {
        setTimeout(() => { // setTimeout fix bug delete on Safari
            validateAndLoadDataInputSS($(_this), key, maxlength);
        }, 300);
    } else {
        validateAndLoadDataInputSS($(_this), key, maxlength);
    }
}

function detectWidthTextBox() {
   var ww = $(window).width();
    if (ww <= 768) {
        stylingStaffItems = $(".js_styling_staff_items .js_styling_staff_item")
        if (stylingStaffItems.length > 0) {
            var firstActiveItem = $(stylingStaffItems[0]);
            var itemWidth = firstActiveItem.width();
            $(stylingStaffItems).find('.custom__popup-add').css({'width': itemWidth + 'px'});
        }
    }
}

$(window).on('load resize', function () {
    detectWidthTextBox();
});

//handle wishlist
$('body').on('click', '.add-staff-styling-no-login-custom img', function () {
    var $icon = $(this);
    var $popup = $('.staff-styling-add-wishlist-custom'); 

    $popup.not($icon.data('popup')).addClass('d-none');

    // position compare with viewport
    var iconOffset = $icon.offset();
    var iconHeight = $icon.outerHeight();

    // Calculate postiion popup (below icon)
    var topPos = (iconOffset.top + iconHeight + 8) - 140;

    $popup.css({
        position: 'absolute',
        top: topPos + 'px',
    });

    if ($popup.hasClass('d-none')) {
        $popup.removeClass('d-none');
        $icon.data('popup', $popup); 
    } else {
        $popup.addClass('d-none');
        $icon.removeData('popup');
    }

    // Update URL redirect 
    var redirect = window.location.href;
    var url = $('.staff-styling-url-redirect-custom').data('href');
    $('.staff-styling-url-redirect-custom').attr('href', url + '?redirect=' + redirect);
});